import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SingleStationPosState {
  active_order_id: string | null;
  setActiveOrder: (id: string | null) => void;
}

/**
 * Persisted across reloads so the single-station cashier-doctor doesn't lose the order
 * mid-sale on a page refresh — mirrors `doctorPosStore`'s `active_draft_id` pattern.
 */
export const useSingleStationPosStore = create<SingleStationPosState>()(
  persist(
    (set) => ({
      active_order_id: null,
      setActiveOrder: (id) => set({ active_order_id: id }),
    }),
    {
      name: 'totem:single_station_pos',
      partialize: (s) => ({ active_order_id: s.active_order_id }),
    },
  ),
);
